export const GET_LIST_START = "@software/GET_LIST_START";
export const GET_LIST_SUCCESS = "@software/GET_LIST_SUCCESS";
export const GET_LIST_FAIL = "@software/GET_LIST_FAIL";
export const GET_DETAIL_START = "@software/GET_DETAIL_START";
export const GET_DETAIL_SUCCESS = "@software/GET_DETAIL_SUCCESS";
export const GET_DETAIL_FAIL = "@software/GET_DETAIL_FAIL";
export const GET_SOFTWARE_INTEGRATIONS_START = "@software/GET_SOFTWARE_INTEGRATIONS_START";
export const GET_SOFTWARE_INTEGRATIONS_SUCCESS = "@software/GET_SOFTWARE_INTEGRATIONS_SUCCESS";
export const GET_SOFTWARE_INTEGRATIONS_FAIL = "@software/GET_SOFTWARE_INTEGRATIONS_FAIL";
export const GET_SOFTWARE_JURISDICTIONS_START = "@software/GET_SOFTWARE_JURISDICTIONS_START";
export const GET_SOFTWARE_JURISDICTIONS_SUCCESS = "@software/GET_SOFTWARE_JURISDICTIONS_SUCCESS";
export const GET_SOFTWARE_JURISDICTIONS_FAIL = "@software/GET_SOFTWARE_JURISDICTIONS_FAIL";
export const UPDATE_INTEGRATIONS_ORDER_START = "@software/UPDATE_INTEGRATIONS_ORDER_START";
export const UPDATE_INTEGRATIONS_ORDER_SUCCESS = "@software/UPDATE_INTEGRATIONS_ORDER_SUCCESS";
export const UPDATE_INTEGRATIONS_ORDER_FAIL = "@software/UPDATE_INTEGRATIONS_ORDER_FAIL";
